<header class="app-header navbar">
  <span class="p-text-center">
    <img  loading="lazy"  alt="Card" src="assets/img/brand/avianca-cargo-logo-white.jpg" style="height: 45px">
  </span>
</header>
<div class="app-body">
  <main class="main">
    <div class="container-fluid" style="margin: 30px 0 ;">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
